import { IProject } from "../../types";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useGlobalStore } from "@/store/GlobalStore";
import { Button } from "@renderbus/ui";

export function ProjectMember(row: IProject) {
  const { users } = row;
  const ShowCount = 2;
  const [showMore, setShowMore] = useState(false);
  const t = getTranslateNsT("center");
  const { userInfo } = useGlobalStore();

  useEffect(() => {
    setShowMore(row.users.length <= ShowCount);
  }, [row]);

  return (
    <MemberWrapper>
      {`${userInfo?.userName}(${t("user_com_childPro_son_user_render_admin")})`}
      {users.slice(0, ShowCount).map((user) => (
        <span key={user.userName}>{user.userName}</span>
      ))}
      {showMore &&
        users
          .slice(ShowCount)
          .map((user) => <span key={user.userName}>{user.userName}</span>)}
      {!showMore && (
        <MoreButton type="text" onClick={() => setShowMore(true)}>
          {t("user_com_private_sub_privilege_more")}
        </MoreButton>
      )}
    </MemberWrapper>
  );
}

const MemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const MoreButton = styled(Button)`
  width: min-content;
  padding: 0;
  color: #13cb75;
  &:hover {
    color: #13cb75 !important;
  }
`;
